import { getMessaging, getToken } from 'firebase/messaging';
import { User } from 'server/shared/models/user';
import { publicVapidKey } from 'server/helpers/push-config';

export async function getPushToken(user: User): Promise<string | undefined> {
  if (!user) {
    return;
  }
  const messaging = getMessaging();
  return await getToken(messaging, {
    vapidKey: publicVapidKey,
    serviceWorkerRegistration: await navigator.serviceWorker.getRegistration(
      '../sw.js',
    ),
  });
}
